import { Inject, Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse, HttpErrorResponse } from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { retry, catchError, tap } from "rxjs/operators";
import { InboxService } from './services/inbox.service';
import { AuthPromptService } from './auth/auth-prompt.service';
import { AppUtils } from './common/utility/appUtil';
import { environment } from '../environments/environment';
import { ERROR_MESSAGE_SETTER } from './app.tokens';
import type { IErrorMessageSetter } from './app.tokens';

@Injectable()
export class ServerErrorInterceptor implements HttpInterceptor {
  constructor(
    private readonly inboxService: InboxService,
    private readonly router: Router,
    private readonly authPromptService: AuthPromptService,
    @Inject(ERROR_MESSAGE_SETTER) private readonly errorMessageSetter: IErrorMessageSetter
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        console.log("Before making api call : ", request);
        switch(request.url){
          case "/QMA2/inquiry/getGridViewData": {
            const startServiceCall = performance.now();
            return next.handle(request).pipe(
              catchError((error: HttpErrorResponse) => {
                if (error.status === 401 && this.router.url.split('?')[0] !== '/error') {
                  this.authPromptService.promptLogin();
                }
                return throwError(error);
              }),
              tap((res: any) => {
                if (res.status && res.status === 200) {
                  if (!environment.production) {
                    const endServiceCall = performance.now();
                    const responseTime = endServiceCall - startServiceCall;
                    const minSec =  AppUtils.millisToMinutesAndSeconds(responseTime)
                    console.warn("QMA Call to getGridViewData >" + request.body.viewName + " took " + responseTime + " milliseconds.");
                    console.warn("QMA Call to getGridViewData >" + request.body.viewName + " took " + minSec + " Min:Seconds.");
                  }
                  this.inboxService.triggerHttpSuccess(res.status);
                }
              })

            );
          }
          default:{
            const startServiceCall = performance.now();
            if(request.url.includes("XXXXX") && request.url.includes("XXXXX")) {
              // clone request and replace 'http://' with 'https://' at the same time
              const secureReq = request.clone({
                url: request.url.replace('http://', 'https://')
              });
              // send the cloned, "secure" request to the next handler.
                return next.handle(secureReq);  
            }
            return next.handle(request).pipe(
              catchError((error: HttpErrorResponse) => {
                const url = request.url;
                const isGetLoginUserInfo = url.includes('/getLoginUserInfo') && !url.includes('getLoginUserInfoDB') && !url.includes('getLoginUserInfoStatic') && !url.includes('getLoginUserInfoConfig');
                if (isGetLoginUserInfo && (error.status === 401 || error.status === 403 || error.status === 500)) {
                  const path = this.router.url.split('?')[0];
                  if (path !== '/error') {
                    const heading = error.status === 403 ? 'User forbidden' : 'Service Unavailable';
                    const msg = error.status === 403
                      ? 'You are not authorized to access this application.'
                      : "We're currently experiencing some technical difficulties. Please try again later. If the issue persists, contact support at DC_QwynSupport.";
                    this.errorMessageSetter.errorMessageHeading.next(heading);
                    this.errorMessageSetter.errorMessage.next(msg);
                    this.router.navigate(['/error']);
                  }
                } else if (error.status === 401 && this.router.url.split('?')[0] !== '/error') {
                  this.authPromptService.promptLogin();
                }
                return throwError(error);
              }),
              tap((res: any) => {
                if (res.status && res.status === 200) {
                  if (!environment.production) {
                    const endServiceCall = performance.now();
                    const responseTime = endServiceCall - startServiceCall;
                    const minSec =  AppUtils.millisToMinutesAndSeconds(responseTime)
                    console.warn("QMA Call to:- "+ request.url +  " took " + responseTime + " milliseconds.");
                    console.warn("QMA Call to:- " + request.url + " took " + minSec + " Min:Seconds.");
                  }
                  this.inboxService.triggerHttpSuccess(res.status);
                }
              })
  
            );  
          }
        }
          
    }
}